import { createStore, combineReducers } from 'redux';
import { authReducer } from './reducers/auth_reducer';
import { userReducer } from './reducers/user_reducer';

export default createStore(combineReducers({
    auth: authReducer,
    user: userReducer,
}));
